export default __webpack_public_path__ + "static/media/3-large.f97945b1.webp";